import addOnKey from './addOnKey';

export default function getItemModsForItemExpanded(
  inventory,
  sale,
  pkg,
  newFieldValue = {}
) {
  const pkgAddOns = inventory.addOns[addOnKey(sale.day, pkg)];
  if (!pkgAddOns) {
    return [];
  }
  const mods = pkgAddOns
    .filter(
      addOn =>
        Object.keys(newFieldValue[pkg.item_id] || {}).indexOf(
          `${addOn.item_id}`
        ) > -1
    )
    .map(addOn => {
      return {
        item: addOn.item,
        category: addOn.category,
        department: addOn.department,
        qty: newFieldValue[pkg.item_id][addOn.item_id].qty
      };
    });
  return mods;
}
